import Form from 'react-bootstrap/Form';
import { Typography } from 'app/components/ui';
import { i18n } from 'app/utils/i18n';
import { useUpdateTag } from 'app/api/tag-queries';

interface NilSwitchProps {
  tagId: string;
  documentSuperId: number;
  currentNilValue: boolean;
  disabled?: boolean;
}

export const NilSwitch = ({ tagId, documentSuperId, currentNilValue, disabled = false }: NilSwitchProps) => {
  const { mutate: updateTag } = useUpdateTag();

  const handleUpdate = (nil: boolean) => {
    updateTag({
      id: tagId,
      documentSuperId,
      nil,
    });
  };

  return (
    <div className="property-row">
      <Typography fontWeight="semibold" className="property-label">
        {i18n('tag.nil.title')}
      </Typography>
      <Form.Check
        type="switch"
        id={`nil-switch-${tagId}`}
        checked={currentNilValue}
        onChange={(e) => handleUpdate(e.target.checked)}
        disabled={disabled}
        style={disabled ? { cursor: 'not-allowed' } : undefined}
      />
    </div>
  );
};
